// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Patch from "common/src/Patch.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as FullSearch from "../components/FullSearch.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PlMatchSummary from "../player/PlMatchSummary.bs.js";
import * as PositionSquare from "../player/PositionSquare.bs.js";
import Format from "date-fns/format";
import IsToday from "date-fns/isToday";
import IsSameDay from "date-fns/isSameDay";
import IsThisWeek from "date-fns/isThisWeek";
import IsYesterday from "date-fns/isYesterday";
import CircularProgress from "@mui/material/CircularProgress";

var Styles = {
  tab: "text-[13px] min-w-[58px] py-2 px-3"
};

function withBreakpoints(heroParticipants, set) {
  var rez = [];
  var lastMatch = {
    contents: undefined
  };
  var firstProperBreakpoint = {
    contents: true
  };
  Belt_Array.forEach(heroParticipants, (function (param) {
          var heroParticipant = param[0];
          var dateHeroParticipants = Belt_Array.keep(heroParticipants, (function (param) {
                  var hp = param[0];
                  if (param[1] && IsSameDay(new Date(hp.dateTime - 0), new Date(heroParticipant.dateTime - 0))) {
                    return hp.patch === heroParticipant.patch;
                  } else {
                    return false;
                  }
                }));
          var games = dateHeroParticipants.length;
          var top4s = Belt_Array.keep(dateHeroParticipants, (function (param) {
                  var hp = param[0];
                  if (hp.info.placement >= 1) {
                    return hp.info.placement <= 4;
                  } else {
                    return false;
                  }
                })).length;
          var wins = Belt_Array.keep(dateHeroParticipants, (function (param) {
                  return param[0].info.placement === 1;
                })).length;
          var avgPlace = Global.f(Belt_Array.reduce(dateHeroParticipants, 0, (function (acc, param) {
                      return acc + param[0].info.placement | 0;
                    }))) / Global.f(dateHeroParticipants.length);
          var lpDelta = Belt_Array.reduce(dateHeroParticipants, 0, (function (acc, param) {
                  var hp = param[0];
                  var match = hp.rankBefore;
                  var match$1 = hp.rankAfter;
                  return acc + (
                          match !== undefined && match$1 !== undefined ? (LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0) - (LpChartUtils.divisionToBase(match[0], set) + match[1] | 0) | 0 : 0
                        ) | 0;
                }));
          var lastHeroParticipant = lastMatch.contents;
          if (lastHeroParticipant !== undefined) {
            if ((!IsSameDay(new Date(lastHeroParticipant.dateTime - 0), new Date(heroParticipant.dateTime - 0)) || heroParticipant.patch !== lastHeroParticipant.patch) && firstProperBreakpoint.contents) {
              if (games > 0) {
                firstProperBreakpoint.contents = false;
              }
              rez.push({
                    TAG: /* Breakpoint */1,
                    _0: {
                      date: Caml_option.some(new Date(heroParticipant.dateTime)),
                      patch: heroParticipant.patch,
                      games: games,
                      top4s: top4s,
                      wins: wins,
                      avgPlace: avgPlace,
                      lpDelta: lpDelta
                    }
                  });
            } else {
              var match = !IsSameDay(new Date(lastHeroParticipant.dateTime - 0), new Date(heroParticipant.dateTime - 0));
              var match$1 = heroParticipant.patch !== lastHeroParticipant.patch;
              if (match) {
                if (match$1) {
                  rez.push({
                        TAG: /* Breakpoint */1,
                        _0: {
                          date: Caml_option.some(new Date(heroParticipant.dateTime)),
                          patch: heroParticipant.patch,
                          games: games,
                          top4s: top4s,
                          wins: wins,
                          avgPlace: avgPlace,
                          lpDelta: lpDelta
                        }
                      });
                } else {
                  rez.push({
                        TAG: /* Breakpoint */1,
                        _0: {
                          date: Caml_option.some(new Date(heroParticipant.dateTime)),
                          patch: undefined,
                          games: games,
                          top4s: top4s,
                          wins: wins,
                          avgPlace: avgPlace,
                          lpDelta: lpDelta
                        }
                      });
                }
              } else if (match$1) {
                rez.push({
                      TAG: /* Breakpoint */1,
                      _0: {
                        date: undefined,
                        patch: heroParticipant.patch,
                        games: games,
                        top4s: top4s,
                        wins: wins,
                        avgPlace: avgPlace,
                        lpDelta: lpDelta
                      }
                    });
              }
              
            }
          } else {
            rez.push({
                  TAG: /* Breakpoint */1,
                  _0: {
                    date: Caml_option.some(new Date(heroParticipant.dateTime)),
                    patch: heroParticipant.patch,
                    games: games,
                    top4s: top4s,
                    wins: wins,
                    avgPlace: avgPlace,
                    lpDelta: lpDelta
                  }
                });
            if (games > 0) {
              firstProperBreakpoint.contents = false;
            }
            
          }
          rez.push({
                TAG: /* Match */0,
                _0: heroParticipant,
                _1: param[1]
              });
          lastMatch.contents = heroParticipant;
          
        }));
  return rez;
}

function formatDate(date) {
  if (IsToday(date)) {
    return "Today";
  } else if (IsYesterday(date)) {
    return "Yesterday";
  } else if (IsThisWeek(date)) {
    return Format(date, "EEEE");
  } else {
    return Format(date, "MMM d");
  }
}

var placeholder = "bg-bg0 w-full h-[40px] mb-[-40px] elevation-2";

function wrap(t, z) {
  return CssJs.merge([
              "flex justify-between w-full text-[13px] sm:text-[16px] pl-4 sm:pl-10 py-3 sticky font-semibold font-montserrat",
              CssJs.style([
                    CssJs.top(CssJs.px(t + 63 | 0)),
                    CssJs.zIndex(z)
                  ])
            ]);
}

var patchBase = CssJs.merge([
      "w-12 sm:w-[60px] pr-[7px] sm:pr-[10px] mr-[7px] sm:mr-[10px]",
      CssJs.style([CssJs.borderRight(CssJs.px(1), CssJs.solid, CssJs.hex("b4b4b4"))])
    ]);

var patch = CssJs.merge([
      "bg-bg0",
      patchBase
    ]);

var dateEmpty = "w-[66px] sm:w-[98px] p-[1px] m-[-1px]";

var date = "bg-bg0 w-[66px] sm:w-[98px] p-[1px] m-[-1px]";

var gamesBase = CssJs.merge([
      "text-right w-[50px] sm:w-[62px] pr-[7px] sm:pr-[10px] mr-[6px] sm:mr-[10px]",
      CssJs.style([CssJs.borderRight(CssJs.px(1), CssJs.solid, CssJs.hex("b4b4b4"))])
    ]);

var games = CssJs.merge([
      "bg-bg0",
      gamesBase
    ]);

var top4Base = CssJs.merge([
      "text-right w-[41px] sm:w-[51px] pr-[7px] sm:pr-[10px] mr-[6px] sm:mr-[10px]",
      CssJs.style([CssJs.borderRight(CssJs.px(1), CssJs.solid, CssJs.hex("b4b4b4"))])
    ]);

var top4 = CssJs.merge([
      "bg-bg0",
      top4Base
    ]);

var winBase = CssJs.merge([
      "text-right w-[30px] sm:w-[38px] pr-[7px] sm:pr-[10px] mr-[6px] sm:mr-[10px]",
      CssJs.style([CssJs.borderRight(CssJs.px(1), CssJs.solid, CssJs.hex("b4b4b4"))])
    ]);

var win = CssJs.merge([
      "bg-bg0",
      winBase
    ]);

var avgPlaceBase = CssJs.merge([
      CssJs.merge(["text-right w-[44px] sm:w-[52px] pr-[7px] sm:pr-[10px] mr-[6px] sm:mr-[10px]"]),
      CssJs.style([CssJs.borderRight(CssJs.px(1), CssJs.solid, CssJs.hex("b4b4b4"))])
    ]);

var avgPlace = CssJs.merge([
      "bg-bg0",
      avgPlaceBase
    ]);

var lpBase = "text-right w-[44px] sm:w-[80px] pr-3 sm:pr-10";

var lp = "bg-bg0 text-right w-[44px] sm:w-[80px] pr-3 sm:pr-10";

var Styles$1 = {
  placeholder: placeholder,
  wrap: wrap,
  patchBase: patchBase,
  patchEmpty: patchBase,
  patch: patch,
  dateEmpty: dateEmpty,
  date: date,
  gamesBase: gamesBase,
  games: games,
  top4Base: top4Base,
  top4: top4,
  winBase: winBase,
  win: win,
  avgPlaceBase: avgPlaceBase,
  avgPlace: avgPlace,
  lpBase: lpBase,
  lp: lp
};

function PlMatchList$Breakpoint(Props) {
  var z = Props.z;
  var t = Props.top;
  var breakpoint = Props.breakpoint;
  var lpDelta = breakpoint.lpDelta;
  var patch$1 = breakpoint.patch;
  var date$1 = breakpoint.date;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "h-2"
                }), React.createElement("div", {
                  className: placeholder
                }), React.createElement("div", {
                  className: wrap(t, z)
                }, React.createElement("div", {
                      className: "flex"
                    }, patch$1 !== undefined ? React.createElement("div", {
                            className: patch
                          }, Patch.render(patch$1)) : React.createElement("div", {
                            className: patchBase
                          }), date$1 !== undefined ? React.createElement("div", {
                            className: date
                          }, formatDate(Caml_option.valFromOption(date$1))) : React.createElement("div", {
                            className: dateEmpty
                          })), React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: games
                        }, String(breakpoint.games)), React.createElement("div", {
                          className: top4
                        }, String(breakpoint.top4s)), React.createElement("div", {
                          className: win
                        }, String(breakpoint.wins)), React.createElement("div", {
                          className: avgPlace
                        }, breakpoint.avgPlace.toFixed(2)), React.createElement("div", {
                          className: lp + " " + (
                            lpDelta > 0 ? "text-green-9" : (
                                lpDelta < 0 ? "text-red-9" : ""
                              )
                          )
                        }, (
                          lpDelta > 0 ? "+" : (
                              lpDelta < 0 ? "-" : ""
                            )
                        ) + String(Math.abs(lpDelta))))), React.createElement("div", {
                  className: "h-2"
                }));
}

var make = React.memo(PlMatchList$Breakpoint);

var Breakpoint = {
  Styles: Styles$1,
  make: make
};

function PlMatchList$TopHeader(Props) {
  var t = Props.t;
  var breakpoint = Props.breakpoint;
  React.useState(function () {
        return false;
      });
  var lpDelta = breakpoint.lpDelta;
  var headerText = "pb-1 whitespace-nowrap";
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: CssJs.merge([
                        "max-w-[100vw] sticky z-[20] h-[30px] bg-primary-12 mt-[7px] elevation-8",
                        CssJs.style([CssJs.top(CssJs.px(t + 29 | 0))])
                      ])
                }), React.createElement("div", {
                  className: CssJs.merge([
                        "flex justify-between bg-bg0 sticky text-[13px] sm:text-[16px] pl-4 sm:pl-10 py-3 w-full mt-[-37px]",
                        CssJs.style([
                              CssJs.zIndex(21),
                              CssJs.top(CssJs.px(t + 43 | 0))
                            ])
                      ]),
                  id: "nav-container"
                }, React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: patchBase
                        }, React.createElement("div", {
                              className: headerText
                            }, "Patch"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, Patch.render(Belt_Option.getExn(breakpoint.patch)))), React.createElement("div", {
                          className: "w-12 sm:w-[60px]"
                        }, React.createElement("div", {
                              className: headerText
                            }, "Date"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, formatDate(Belt_Option.getExn(breakpoint.date))))), React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: gamesBase
                        }, React.createElement("div", {
                              className: headerText
                            }, "Games"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, String(breakpoint.games))), React.createElement("div", {
                          className: top4Base
                        }, React.createElement("div", {
                              className: headerText
                            }, "Top 4"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, String(breakpoint.top4s))), React.createElement("div", {
                          className: winBase
                        }, React.createElement("div", {
                              className: headerText
                            }, "Win"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, String(breakpoint.wins))), React.createElement("div", {
                          className: avgPlaceBase
                        }, React.createElement("div", {
                              className: headerText
                            }, "Place"), React.createElement("span", {
                              className: "font-semibold font-montserrat"
                            }, breakpoint.avgPlace.toFixed(2))), React.createElement("div", {
                          className: lpBase
                        }, React.createElement("div", {
                              className: headerText
                            }, "LP"), React.createElement("span", {
                              className: "font-semibold font-montserrat " + (
                                lpDelta > 0 ? "text-green-9" : (
                                    lpDelta < 0 ? "text-red-9" : ""
                                  )
                              )
                            }, (
                              lpDelta > 0 ? "+" : (
                                  lpDelta < 0 ? "-" : ""
                                )
                            ) + String(Math.abs(lpDelta)))))));
}

var make$1 = React.memo(PlMatchList$TopHeader);

var TopHeader = {
  make: make$1
};

function filterMatch(hp, filters) {
  if (filters.length === 0) {
    return true;
  }
  var normMatch = Belt_Array.every(filters, (function (filter) {
          switch (filter.TAG | 0) {
            case /* Unit */0 :
                var unitId = filter._0;
                return Belt_Array.some(hp.info.units, (function (u) {
                              if (u.id === unitId) {
                                return true;
                              } else {
                                return u.id === unitId.toLowerCase();
                              }
                            }));
            case /* Trait */1 :
                var rank = filter._1;
                var traitId = filter._0;
                return Belt_Array.some(hp.info.traits, (function (t) {
                              if (t.name === traitId) {
                                return t.currentTier >= rank;
                              } else {
                                return false;
                              }
                            }));
            case /* Item */2 :
                var itemId = filter._0;
                return Belt_Array.some(hp.info.units, (function (u) {
                              return Belt_Array.some(u.items2, (function (i) {
                                            return i.includes(itemId);
                                          }));
                            }));
            case /* Augment */3 :
                var augId = filter._0;
                return Belt_Array.some(Belt_Option.getWithDefault(hp.info.augments, []), (function (aid) {
                              return augId === Data.encodeAugmentId(aid);
                            }));
            case /* Places */4 :
                return true;
            
          }
        }));
  var placeFilters = Belt_Array.keepMap(filters, (function (f) {
          if (f.TAG === /* Places */4) {
            return f._1;
          }
          
        }));
  var placeMatch = placeFilters.length === 0 || Belt_Array.some(placeFilters, (function (places) {
          return places.includes(hp.info.placement);
        }));
  if (normMatch) {
    return placeMatch;
  } else {
    return false;
  }
}

function PlMatchList$Inner(Props) {
  var pendingQueueId = Props.pendingQueueId;
  var typ = Props.typ;
  var heroParticipants = Props.heroParticipants;
  var onShowDetails = Props.onShowDetails;
  var t = Props.top;
  var onHoverMatch = Props.onHoverMatch;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return [];
      });
  var setNewFilters = match[1];
  var newFilters = match[0];
  var match$1 = React.useState(function () {
        return 20;
      });
  var setRenderElements = match$1[1];
  var renderElements = match$1[0];
  var searchOptions = React.useMemo((function () {
          return FullSearch.getPlayerOptions(set);
        }), []);
  var throttle = React.useRef(false);
  var visibleHeroParticipants = {
    contents: 0
  };
  var match$2 = React.useMemo((function () {
          visibleHeroParticipants.contents = 0;
          var hps = Belt_Array.map(heroParticipants, (function (hp) {
                  var visible = false;
                  if (filterMatch(hp, newFilters)) {
                    var tmp;
                    switch (typ) {
                      case /* All */0 :
                          tmp = hp.queueId !== 1220;
                          break;
                      case /* Ranked */1 :
                          tmp = hp.queueId === 1100;
                          break;
                      case /* Normal */2 :
                          tmp = hp.queueId === 1090;
                          break;
                      case /* Hyperroll */3 :
                          tmp = hp.queueId === 1130;
                          break;
                      case /* Duo */4 :
                          tmp = hp.queueId === 1150 || hp.queueId === 1160;
                          break;
                      
                    }
                    visible = tmp;
                  }
                  if (visible) {
                    visibleHeroParticipants.contents = visibleHeroParticipants.contents + 1 | 0;
                  }
                  return [
                          hp,
                          visible
                        ];
                }));
          var contents = withBreakpoints(hps, set);
          return [
                  hps,
                  contents
                ];
        }), [
        typ,
        newFilters,
        heroParticipants
      ]);
  var contents = match$2[1];
  var heroParticipants$1 = match$2[0];
  React.useEffect((function () {
          var cb = function (param) {
            var sh = document.documentElement.scrollHeight;
            var scrollY = window.scrollY | 0;
            var ih = window.innerHeight;
            if ((sh - (scrollY + ih | 0) | 0) < 350 && renderElements < contents.length && !throttle.current) {
              Curry._1(setRenderElements, (function (re) {
                      return re + 20 | 0;
                    }));
              throttle.current = true;
              setTimeout((function (param) {
                      throttle.current = false;
                      return cb(undefined);
                    }), visibleHeroParticipants.contents < 10 ? 50 : 300);
              return ;
            }
            
          };
          window.addEventListener("scroll", cb, {
                passive: true,
                capture: false,
                once: false
              });
          return (function (param) {
                    window.removeEventListener("resize", cb);
                    
                  });
        }), []);
  React.useEffect((function () {
          var cb = function (param) {
            var sh = document.documentElement.scrollHeight;
            var scrollY = window.scrollY | 0;
            var ih = window.innerHeight;
            if ((sh - (scrollY + ih | 0) | 0) < 350 && renderElements < contents.length && !throttle.current) {
              Curry._1(setRenderElements, (function (re) {
                      return re + 20 | 0;
                    }));
              throttle.current = true;
              setTimeout((function (param) {
                      throttle.current = false;
                      return cb(undefined);
                    }), visibleHeroParticipants.contents < 10 ? 50 : 300);
              return ;
            }
            
          };
          cb(undefined);
          
        }), [newFilters]);
  var odd = {
    contents: false
  };
  var firstHeader = {
    contents: true
  };
  return React.createElement(ContentSection.make, {
              className: "px-0 py-2 w-full max-w-[375px] sm:max-w-[694px] md:w-[850px] md:max-w-[initial]",
              children: null
            }, React.createElement("div", {
                  className: "flex gap-2 flex-col sm:flex-row px-4 pb-4 justify-between sm:items-center"
                }, React.createElement("h4", {
                      className: "text-xl font-medium"
                    }, "Matches"), React.createElement("div", {
                      className: "flex items-center gap-2"
                    }, React.createElement("div", {
                          className: "text-lg font-montserrat font-medium"
                        }, "Filters:"), React.createElement("div", {
                          className: "flex gap-1"
                        }, Belt_Array.mapWithIndex(newFilters, (function (idx, f) {
                                var tmp;
                                switch (f.TAG | 0) {
                                  case /* Unit */0 :
                                      tmp = React.createElement(UnitImage.make, {
                                            unitId: f._0,
                                            size: 28
                                          });
                                      break;
                                  case /* Trait */1 :
                                      tmp = React.createElement(TraitImage.PlainIcon2.make, {
                                            traitId: f._0,
                                            rank: f._1,
                                            size: 28
                                          });
                                      break;
                                  case /* Item */2 :
                                      tmp = React.createElement(ItemImage.make, {
                                            itemId: f._0,
                                            size: 28,
                                            rounded: "rounded"
                                          });
                                      break;
                                  case /* Augment */3 :
                                      tmp = React.createElement(AugmentImage.make, {
                                            augId: f._0,
                                            size: 28
                                          });
                                      break;
                                  case /* Places */4 :
                                      tmp = React.createElement(PositionSquare.make, {
                                            size: 26,
                                            pl: Belt_Array.getExn(f._1, 0),
                                            queueId: 1100
                                          });
                                      break;
                                  
                                }
                                return React.createElement(FullSearch.FilterWrap.make, {
                                            children: tmp,
                                            onClick: (function (param) {
                                                return Curry._1(setNewFilters, (function (nfs) {
                                                              var updated = Belt_Array.keep(nfs, (function (f2) {
                                                                      return Caml_obj.caml_notequal(f2, f);
                                                                    }));
                                                              if (updated.length === 0) {
                                                                Curry._1(setRenderElements, (function (param) {
                                                                        return 20;
                                                                      }));
                                                              }
                                                              return updated;
                                                            }));
                                              }),
                                            key: String(idx)
                                          });
                              }))), React.createElement(FullSearch.make, {
                          onChange: (function (v) {
                              return Curry._1(setNewFilters, (function (fs) {
                                            return Belt_Array.concat(fs, [FullSearch.decodeFilter(v)]);
                                          }));
                            }),
                          placeholder: "Add Filter",
                          options: searchOptions
                        }))), heroParticipants$1.length === 0 ? React.createElement("div", {
                    className: "h-64 w-full text-center color-white2 text-2xl font-montserrat font-semibold pt-16"
                  }, "No matches") : null, Belt_Array.mapWithIndex(Belt_Array.slice(contents, 0, renderElements), (function (idx, content) {
                    if (content.TAG === /* Match */0) {
                      var heroParticipant = content._0;
                      odd.contents = !odd.contents;
                      var tmp;
                      if (idx === 1 && pendingQueueId !== undefined) {
                        var queueName = PlUtils.queueName(pendingQueueId);
                        tmp = React.createElement("div", {
                              className: "pb-4 px-4 flex items-center gap-3"
                            }, React.createElement(CircularProgress, {
                                  size: 18
                                }), React.createElement("div", {
                                  className: "text-sm"
                                }, "A " + queueName + " match is in progress. Results will be available when a winner is decided."));
                      } else {
                        tmp = null;
                      }
                      return React.createElement(React.Fragment, {
                                  children: null,
                                  key: heroParticipant.id
                                }, tmp, React.createElement("div", {
                                      className: [
                                          "py-[4px] player-expandable-match",
                                          odd.contents ? "bg-bg2" : "",
                                          content._1 ? "cv-auto" : "hidden"
                                        ].join(" ")
                                    }, idx < renderElements ? React.createElement(PlMatchSummary.make, {
                                            firstMatch: idx === 0,
                                            heroParticipant: heroParticipant,
                                            onShowDetails: onShowDetails,
                                            onHoverMatch: onHoverMatch
                                          }) : null));
                    }
                    var breakpoint = content._0;
                    if (breakpoint.games === 0) {
                      return null;
                    } else if (firstHeader.contents) {
                      firstHeader.contents = false;
                      return React.createElement(React.Fragment, {
                                  children: null,
                                  key: String(idx)
                                }, React.createElement(make$1, {
                                      t: t,
                                      breakpoint: breakpoint,
                                      heroParticipants: heroParticipants$1
                                    }), React.createElement("div", {
                                      className: "h-4"
                                    }));
                    } else {
                      return React.createElement(make, {
                                  z: 22 + idx | 0,
                                  top: t,
                                  breakpoint: breakpoint,
                                  key: String(idx)
                                });
                    }
                  })), renderElements <= contents.length ? React.createElement("div", {
                    className: "flex justify-center py-4",
                    id: "pl-matchlist-loader"
                  }, React.createElement(CircularProgress, {})) : null);
}

var make$2 = React.memo(PlMatchList$Inner);

var Inner = {
  initRenderElements: 20,
  renderGamesIncrement: 20,
  make: make$2
};

function PlMatchList(Props) {
  var pendingQueueId = Props.pendingQueueId;
  var typ = Props.typ;
  var heroParticipants = Props.heroParticipants;
  var onShowDetails = Props.onShowDetails;
  var top = Props.top;
  var onHoverMatch = Props.onHoverMatch;
  var match = React.useState(function () {
        return false;
      });
  var setRender = match[1];
  React.useEffect((function () {
          Curry._1(setRender, (function (param) {
                  return true;
                }));
          
        }), []);
  if (match[0]) {
    return React.createElement(make$2, {
                pendingQueueId: pendingQueueId,
                typ: typ,
                heroParticipants: heroParticipants,
                onShowDetails: onShowDetails,
                top: top,
                onHoverMatch: onHoverMatch
              });
  } else {
    return null;
  }
}

var dayOffset = 0;

var make$3 = PlMatchList;

export {
  Styles ,
  dayOffset ,
  withBreakpoints ,
  formatDate ,
  Breakpoint ,
  TopHeader ,
  filterMatch ,
  Inner ,
  make$3 as make,
  
}
/* patchBase Not a pure module */
